<template>
    <div style="padding:50px 0px;">
        <div class="tab-pane pt-3 active show" v-if="ready">
            <div class="form-group row" id="radio">
                <div class="radio radio-inline ml-15">
                    <input type="radio" id="big-category-all" v-model="code_category" value="">
                    <label class="round button" for="big-category-all">[全部]</label>
                </div>
                <div class="radio radio-inline" v-for="(big, i) in bigCategory" :key="`coverage-kind-${i}`">
                    <input type="radio" :id="`big-category-${i}`" v-model="code_category" :value="big.codeCategory">
                    <label class="round button" :for="`big-category-${i}`">{{big.name}}({{big.codeCategory}})</label>
                </div>
            </div>
            <section class="row" :class="{'section-loading': isLoading}">
                <table class="table datatable">
                    <thead>
                        <tr>
                            <th style="width:11%" class="text-center">十大保障大類</th>
                            <th style="width:12%" class="text-center">保障中分類代碼</th>
                            <th style="width:15%" class="text-center">保障中分類名稱</th>
                            <th style="width:8%" class="text-center">保障細項</th>
                            <th style="width:12%" class="text-center">最新更新日期</th>
                            <th style="width:16%" class="text-center">備註</th>
                            <th style="width:8%" class="text-center">編輯</th>
                            <th style="width:6%" class="text-center">狀態</th>
                            <th style="width:12%" class="text-center">覆核生效日期</th>
                        </tr>
                    </thead>
                    <tbody v-if="midCategory.length">
                        <tr v-for="(mid, i) in midCategory" :key="`mid-category-data-${i}`">
                            <template v-for="big in bigCategory">
                              <template v-if="mid.code_category===big.codeCategory">
                                <td :key="`td1-${i}-${big.codeCategory}`">
                                  <div class="item-center">
                                    {{big.name}}({{big.codeCategory}})
                                  </div>
                                </td>                            
                                <td :key="`td2-${i}-${big.codeCategory}`">
                                  <div class="item-center">
                                    {{mid.code}}
                                  </div>
                                </td>
                                <td :key="`td3-${i}-${big.codeCategory}`">{{mid.code_name}}</td>
                                <td :key="`td4-${i}-${big.codeCategory}`">
                                  <div class="item-center">
                                    <button type="button" class="btn btn-default btn-sm" :disabled="mid.status==='0'" @click="openSmallCategoryShowModal(big, mid)">
                                        查詢
                                    </button>
                                  </div>
                                </td>
                                <td :key="`td5-${i}-${big.codeCategory}`">
                                  <div class="item-center">
                                    {{mid.updatetimestamp}}
                                  </div>
                                </td>
                                <td :key="`td6-${i}-${big.codeCategory}`">{{mid.memo}}</td>
                                <td :key="`td7-${i}-${big.codeCategory}`">
                                  <div class="item-center">
                                    <button type="button" class="btn btn-primary btn-sm" @click="openMidCategoryEditModal(big, mid)">
                                        編輯
                                    </button>
                                  </div>
                                </td>
                                <td :key="`td8-${i}-${big.codeCategory}`">
                                  <div v-if="mid.status==='0'">
                                    未生效
                                  </div>
                                  <div v-else>
                                    已生效
                                  </div>                                  
                                </td>
                                <td :key="`td9-${i}-${big.codeCategory}`">
                                  <div class="item-center">
                                    {{mid.checktimestamp}}
                                  </div>
                                </td>
                              </template>
                            </template>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="6">
                                <h4 class="mb-3">查無資料</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <div style="height:30px"></div>
        </div>
        <div v-else>
            <Message
            class="mt-5 d-flex justify-content-center"
            loading
            message="資料讀取中，請稍候..."
            />
        </div>
        <!-- 保障細項顯示 -->      
        <SmallCategoryShowModal          
            :open="smallCategoryShowModalOpen"
            :data="midShowData"
            @confirm="panelClose('smallCategoryShowModalOpen')">
        </SmallCategoryShowModal>
        <fixed-bottom v-show="!isScroll">
            <template slot="@function">
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-primary mr-0"
                  v-show="!isIpad()"
                  @click="showExcel(true)"
                  type="button"
                >
                  下載保障群組明細
                </button>
              </div>
            </template>
          </fixed-bottom>
    </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import SmallCategoryShowModal from "./components/SmallCategoryShowModal.vue";
import ThisMixin from "./util/CoverageCategory.js";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import { queryMidCategory, getExcel, getExcelData } from "@/service";


export default {
  name: "CoverageCategoryGroup",
  mixins: [ThisMixin],
  components: {
    Message,
    SmallCategoryShowModal,
    FixedBottom,
  },
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ready() {
      return !window._.isEmpty(this.midCategory);
    },
  },
  data() {
    return {
      code_category: "",
      midCategory: [],
      midShowData: { bigName: "", midCode: "", midName: "" },
      //存放保障細項
      smallCategory: [],
      //是否讀取資料中
      isLoading: false,
      //保障細項顯示是否打開
      smallCategoryShowModalOpen: false,
      //十大保障分類從CoverageCategory.js取得
      //bigCategory: []
      //是否滾動
      isScroll: false,
    };
  },
  mounted() {
    const category = sessionStorage.getItem('category')
    this.code_category = category == undefined ? '' : category
    sessionStorage.removeItem('category')
    this.getMidCategory();
  },
  watch: {
    //當上列十大保障點選切換時重新查詢該類
    code_category() {
      this.getMidCategory();
    },
    reload(val) {
      if (val) {
        this.getMidCategory();
      }
    },
  },
  methods: {
    /** 取得保障中分類 */
    async getMidCategory() {
      this.isLoading = true;
      await queryMidCategory(
        this.$store.state.userInfo.id,
        this.code_category
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.midCategory = result.data;
        } else {
          this.midCategory = [];
        }
        this.isLoading = false;
      });
    },
    /** 打開查詢保障細項 */
    async openSmallCategoryShowModal(big, mid) {
      this.midShowData.bigName = big.name;
      this.midShowData.midCode = mid.code;
      this.midShowData.midName = mid.code_name;
      this.panelOpen("smallCategoryShowModalOpen");
    },
    /** 打開編輯保障群組 */
    openMidCategoryEditModal(big, mid) {
      this.$router.push({ name: 'MidCategoryEditModal', params: {big: big, mid: mid} })
      sessionStorage.setItem('category',this.code_category)

    },
    showExcel(isDownload) {
      this.isDownload = isDownload;
      this.printExcel();
    },
    printExcel() {
      this.serverEdit = false;
      // 若為webview開啟則不開新視窗
      // let newWindow = this.isWebView() ? window : this.openNewWindow();
      // let newWindow = window;

      // 查詢Excel資料後下載報表------------------------------------------------
      let body = {
        data:[]
      }
      // 查詢API取得列印資料
      getExcelData(this.agidno, this.code_category).then((result) => {
        body.data = result.data
        getExcel(this.agidno, body).then((result) => {
            setTimeout(() => {
              let file = new Blob([result], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              // this.sendPdfDataToApp(file, fileName);
              const today = new Date();
              const minKuoYear = today.getFullYear() - 1911;
              const month = String(today.getMonth() + 1).padStart(2, '0');
              const day = String(today.getDate()).padStart(2, '0');
              let date = minKuoYear+month+day;

              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, '保障群組明細_'+date);
              } else {
                if (this.isDownload) {
                  this.chromeDonloadFile(file, '保障群組明細_'+date, false);
                }
              }
            }, 1000);
          
        });
      })

    },
  },
};
</script>

<style scoped>
#radio .radio input + label:before,
#radio .radio input:checked + label:after {
  display: none !important;
}
#radio .radio {
  margin-right: 0px;
}
#radio input:checked + .button {
  background: #fef3e7;
  color: #f58818;
  border: 1px solid #f58818;
  cursor: default;
}
#radio .button {
  display: inline-block;
  margin: 0 5px 10px 0;
  padding: 5px 10px;
  background: #f7f7f7;
  border: 1px solid #f7f7f7;
  color: #333;
  cursor: pointer;
}
#radio .button:hover {
  background: #fef3e7;
  color: #f58818;
  border: 1px solid #f58818;
  border-radius: 4px;
}
#radio .round {
  border-radius: 5px;
}
.item-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
